import templateUrl from './rsvp-messages.tpl.html';
import emailModalTemplate from './show-email-modal.tpl.html';

class RsvpMessagesCtrl {

    constructor(Message, $injector, Messages, $scope) {
        this.model = Message;
        this.injector = $injector;
        this.store = Messages.reset({
            persist: false
        });
        this.scope = $scope;
        this._initWatchers();
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.rsvp;
        }, () => {
            if (this.rsvp) {
                this._initStore();
            }
        })
    }

    _initStore() {
        this.store.commit('setPermanentFilters', {
            recipient_id: this.rsvp.id,
            recipient_type: 'rsvp',
        });
        this.store.commit('setVisible', [
            'subject',
            'status',
            'created_at'
        ]);
        this.store.commit('addAction', {
            key: 'details',
            text: 'Details',
            class: 'btn btn-info btn-simple btn-xs',
            icon: 'fa fa-search',
            level: 'row',
            action: this.showMessage
        });
        this.store.commit('addAction', {
            key: 'show_archived',
            title: 'Show archived',
            level: 'settings',
            manager: 'showArchived'
        });

        this.store.commit('setVm', this);
    }

    showMessage(payload, store) {
        store.ng.injector.get('$uibModal').open({
            animation: true,
            size: 'lg',
            templateUrl: emailModalTemplate,
            controller: ['$sce', '$uibModalInstance', 'email', 'Message', function ($sce, $uibModalInstance, email, Message) {
                var vm = this;
                vm.message = email;
                Message.one(email.id).get({include: 'recipient,template'}).then(function (message) {
                    vm.message = message;
                }, function (error) {
                });

                vm.cancel = function () {
                    $uibModalInstance.dismiss();
                }
            }],
            resolve: {
                email: function () {
                    return payload.row;
                }
            },
            controllerAs: 'email'
        });
    }

    archiveManyMessages(rows) {
        const model = this.model.one();
        model.items = [];

        rows.forEach(function (row) {
            model.items.push(row.id);
        });

        return SweetAlert.swal({
                title: locale.getString('sweetalerts.are_you_sure'),
                text: locale.getString('sweetalerts.archiving_records_confirmation_message'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ed5565',
                confirmButtonText: locale.getString('sweetalerts.yes_archive_selected'),
                showLoaderOnConfirm: true,
                closeOnConfirm: false
            },
            function (isConfirm) {
                if (isConfirm) {
                    model.customDELETE().then(function () {
                        setupMessages();
                        SweetAlert.swal(locale.getString('sweetalerts.archive_successful'), locale.getString('sweetalerts.records_archived_message'), 'success');
                    }, function (response) {
                        SweetAlert.swal(locale.getString('sweetalerts.saving_unsuccessful'), response.data.message, 'error');
                    });
                }
            });
    }

    restoreManyMessages(rows) {

        // @todo new alert - check if used anywhere

        var items = [];

        rows.forEach(function (row) {
            items.push(row.id);
        });

        return SweetAlert.swal({
                title: locale.getString('sweetalerts.are_you_sure'),
                text: locale.getString('sweetalerts.restoring_records_confirmation_message'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ed5565',
                confirmButtonText: locale.getString('sweetalerts.yes_restore_selected'),
                showLoaderOnConfirm: true,
                closeOnConfirm: false
            },
            function (isConfirm) {
                if (isConfirm) {
                    Message.restoreMany(items).then(function () {
                        setupMessages();
                        SweetAlert.swal(locale.getString('sweetalerts.restore_successful'), locale.getString('sweetalerts.records_restored_message'), 'success');
                    }, function (response) {
                        SweetAlert.swal(locale.getString('sweetalerts.restore_unsuccessful'), response.data.message, 'error');
                    });
                }
            });
    }

    deleteManyMessages(rows) {

        var items = [];

        rows.forEach(function (row) {
            items.push(row.id);
        });

        return SweetAlert.swal({
                title: locale.getString('sweetalerts.are_you_sure'),
                text: locale.getString('sweetalerts.deleting_records_confirmation_message'),
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#ed5565',
                confirmButtonText: locale.getString('sweetalerts.yes_delete_selected'),
                showLoaderOnConfirm: true,
                closeOnConfirm: false
            },
            function (isConfirm) {
                if (isConfirm) {
                    Message.deleteMany(items).then(function () {
                        setupMessages();
                        SweetAlert.swal(locale.getString('sweetalerts.delete_successful'), locale.getString('sweetalerts.records_deleted_message'), 'success');
                    }, function (response) {
                        SweetAlert.swal(locale.getString('sweetalerts.delete_unsuccessful'), response.data.message, 'error');
                    });
                }
            });
    }
}


RsvpMessagesCtrl.$inject = [
    'Message',
    '$injector',
    'Messages',
    '$scope'
];


angular
    .module('festzelt-os.guestlists')
    .component('rsvpMessages', {
        bindings: {
            rsvp: '<'
        },
        controller: RsvpMessagesCtrl,
        controllerAs: 'vm',
        templateUrl: templateUrl
    });




// WEBPACK FOOTER //
// ./src/app/pages/guestlists/components/messages/rsvp-messages.js